<template>
  <v-col
    v-if="capacity && capacity.getCapacity() < capacity.getCount()"
    class="col-12 py-0 px-1 error white--text"
  >
    <span class="fal fa-exclamation-triangle mr-1" />
    <span class="content-5 font-weight-thin font-condensed">
      {{ $t('capacityBellowWarning.bellowWarning') }}
    </span>
    <span v-if="showBookings" class="content-5 font-weight-thin font-condensed">
      &nbsp;({{ capacity.getCount() }})
    </span>
  </v-col>
</template>

<script>
import ValueCapacity from '../../classes-shared/products/ValueCapacity'

export default {
  name: 'CapacityBellowWarning',
  props: {
    capacity: {
      type: ValueCapacity,
      required: true,
    },
    showBookings: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
